module.exports = __webpack_public_path__ + "static/media/bed.d9a0dd29.svg";